import { useCallback, useRef, useState } from "react";
import { isDuplicatePt5Error } from "../utils/propertyErrors";

export function useDuplicatePt5Retry() {
  const [showDuplicatePt5Modal, setShowDuplicatePt5Modal] = useState(false);
  const retryRef = useRef(null);

  const openDuplicatePt5Modal = useCallback((err, retryFn) => {
    if (!isDuplicatePt5Error(err)) return false;
    retryRef.current = retryFn;
    setShowDuplicatePt5Modal(true);
    return true;
  }, []);

  const closeDuplicatePt5Modal = useCallback(() => {
    setShowDuplicatePt5Modal(false);
    retryRef.current = null;
  }, []);

  const saveDuplicatePt5Retry = useCallback(async (newPt5) => {
    const trimmed = String(newPt5 ?? "").trim();
    if (!trimmed) return;

    const retry = retryRef.current;
    retryRef.current = null;
    setShowDuplicatePt5Modal(false);
    if (retry) {
      await retry(trimmed);
    }
  }, []);

  return {
    showDuplicatePt5Modal,
    openDuplicatePt5Modal,
    closeDuplicatePt5Modal,
    saveDuplicatePt5Retry,
  };
}
